
import {LitElementBase,customElement,html} from "#Shared/Lit";
import {AppointmentFieldModel} from "./AppointmentField.Model";
import {DateUtilities} from "./DateUtilities";
import {faCalendarCheck} from "@fortawesome/free-solid-svg-icons/faCalendarCheck";
declare function RNTranslate(param1);
@customElement('rnappointment-appointment-field')
export class AppointmentField extends LitElementBase{
    public model:AppointmentFieldModel;
    public Compact:boolean=false;
    render() {

        return html`
            <div>
                <div style="position: relative;padding: 5px" class="appointmentContainer ${this.Compact?'rnCompact':''}">
                    <rn-appointment-field-calendar .model="${this.model}"></rn-appointment-field-calendar>
                    <rn-appointment-time-picker style="flex-grow: 1" .model="${this.model}"></rn-appointment-time-picker>
                </div>
                ${this.GetSelectedDateMessage()}
            </div>

        `;
    }

    GetDisplay(): string {
        return 'flex';
    }


    private OnChange(x:Date) {
        this.model.Date=DateUtilities.DateToUnix(x);
        this.model.Refresh();
    }


    protected firstUpdated(_changedProperties: any) {
        super.firstUpdated(_changedProperties);
        this.model.OnRefresh.Subscribe(this,()=>{this.forceUpdate()});
        if(this.getBoundingClientRect().width<600)
        {
            this.Compact=true;
            this.forceUpdate();
        }
    }

    private GetSelectedDateMessage() {
        if(this.model.Date!=null&&this.model.flatPickr!=null)
        {
            return html`
                <div class="rnAppointmentSelectedDate">
                    <rn-fontawesome .icon="${faCalendarCheck}" style="margin-right: 5px"></rn-fontawesome>
                    ${RNTranslate('You selected')} ${this.model.GetFormattedDate()}
                </div>`;
        }
    }
}